<template>
    <div id="error" ref="error">
        <div class="notfound-container">
            <div class="img-404"></div>
            <p class="notfound-p">哎呀迷路了...</p>
            <div class="notfound-btn-container">
                <router-link class="notfound-btn" to="/home">返回首页</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Err',
        data() {
            return {
                error: ''
            }
        }
    }
</script>

<style>
    .notfound-container .img-404 {
        height: 155px;
        background: url('../assets/images/404.png') center center no-repeat;
        -webkit-background-size:150px auto;
        padding-top:40px;
        margin-bottom:20px;
    }
    .notfound-container .notfound-p {
        line-height: 22px;
        font-size:17px;
        padding-bottom:15px;
        border-bottom:1px solid #f6f6f6;
        text-align:center;color:#262b31;
    }
    .notfound-container .notfound-btn-container{
        margin:40px auto 0;
        text-align:center;
    }
    .notfound-container .notfound-btn-container .notfound-btn{
        display:inline-block;
        border:1px solid #ebedef;
        background-color:#239bf0;
        color:#fff;
        font-size:15px;
        border-radius:5px;
        text-align:center;
        padding:10px;
        line-height:16px;
        white-space:nowrap;
    }
</style>